import { Ajax } from 'utils/ajax';
import { fancybox } from 'settings';


class AjaxUpdate {
  constructor() {
      this.init();
  }
  init() {
      console.log('[ AjaxUpdate ] init');
      this.updateProduct();
  }
  updateProduct() {
    function newfunk() {
      if ($('.js-cart-add').data('num_id')) {
        $('.js-cart-add').css('display','block');
      }
    }
    console.log('[ AjaxUpdate_Product ]');
    $('.js-check[data-method_type="product"]').change(function(){
          console.log('[ AjaxUpdatePage ] Update_Product');
            if ($(this).prop('checked')) {var upd = "add"; $('.js-add-text').remove();} else { var upd = 'delete'};
              var allInf = {
                method : upd,
                modif_id : $('.js-item__material.item__material--active').data('modif_id'),
                material : $('.js-item__material.item__material--active').data('material'),
                prod_id : $(this).data('prod_id'),
                prod_group : $(this).data('prod_group'),
                prod_type_id : $(this).data('prod_type_id'),
				price: $(this).val()
              }

            $.ajax({method: 'POST', url:'/constructor/Update_Product/', data:allInf, dataType:'json'}).then((data) => {
              if (data.ok) {
                  console.log(data);
                  newfunk();
              }
            })
    })
    $('.js-aksses-input[data-method_type="product"]').change(function(){
          console.log('[ AjaxUpdatePage ] Update_Product');
            if ($(this).prop('checked')) {var upd = "add"} else { var upd = 'delete'};
            if ($(this).closest('.js-aksses').find('.js-number-box').val()) {
              var allInf = {
                method : upd,
                modif_id : $('.js-item__material.item__material--active').data('modif_id'),
                material : $('.js-item__material.item__material--active').data('material'),
                prod_id : $(this).closest('.js-aksses').find('.js-number-box').data('prod_id'),
                prod_group : $(this).closest('.js-aksses').find('.js-number-box').data('prod_group'),
                prod_type_id : $(this).closest('.js-aksses').find('.js-number-box').data('prod_type_id'),
                count: $(this).closest('.js-aksses').find('.js-number-box').val(),
				price: $(this).val()
              }
            } else {
              var allInf = {
                method : upd,
                modif_id : $('.js-item__material.item__material--active').data('modif_id'),
                material : $('.js-item__material.item__material--active').data('material'),
                prod_id : $(this).data('prod_id'),
                prod_group : $(this).data('prod_group'),
                prod_type_id : $(this).data('prod_type_id'),
				price: $(this).val()
              }
            }

            $.ajax({method: 'POST', url:'/constructor/Update_Product/', data:allInf, dataType:'json'}).then((data) => {
              if (data.ok) {
                  console.log(data);
                  newfunk();
              }
            })
    })
    $('.js-number-box[data-method_type="product"]').change(function(){
        if ($(this).closest('.js-aksses').find('.js-aksses-input').prop('checked')) {
          if ($(this).val() == '0') {var upd = "delete"} else { var upd = 'add'};
          var allInf = {
            method : upd,
            modif_id : $('.js-item__material.item__material--active').data('modif_id'),
            material : $('.js-item__material.item__material--active').data('material'),
            prod_id : $(this).data('prod_id'),
            prod_group : $(this).data('prod_group'),
            prod_type_id : $(this).data('prod_type_id'),
            count: $(this).val(),
			price: $(this).val()
          }

          $.ajax({method: 'POST', url:'/constructor/Update_Product/', data:allInf, dataType:'json'}).then((data) => {
            if (data.ok) {
                console.log(data);
                newfunk();
            }
          })
        }
    })
    $('.js-item__counter-block span').click(function() {
      if ($(this).closest('.js-aksses').find('.js-aksses-input').prop('checked')) {
        var newThis = $(this).siblings('.js-number-box');
        setTimeout(function(){
          if (newThis.val() == '0') {var upd = "delete"} else { var upd = 'add'};
          var allInf = {
            method : upd,
            modif_id : $('.js-item__material.item__material--active').data('modif_id'),
            material : $('.js-item__material.item__material--active').data('material'),
            prod_id : newThis.attr('data-prod_id'),
            prod_group : newThis.attr('data-prod_group'),
            prod_type_id : newThis.attr('data-prod_type_id'),
            count: newThis.val()
          }

          $.ajax({method: 'POST', url:'/constructor/Update_Product/', data:allInf, dataType:'json'}).then((data) => {
            if (data.ok) {
                console.log(data);
                newfunk();
            }
          })
        })
      }
    })
    $('input[data-method_type="option"]').change(function(){
          console.log('[ AjaxUpdatePage ] Select_Option');
            var allInf = {
              modif_id : $('.js-item__material.item__material--active').data('modif_id'),
              material : $('.js-item__material.item__material--active').data('material'),
              product_id : $(this).data('prod_id'),
              option_id : $(this).data('option_id'),
              option_header : $(this).data('option_header'),
              option_name : $(this).data('option_name'),
            }

          $.ajax({method: 'POST', url:'/constructor/Select_Option/', data:allInf, dataType:'json'}).then((data) => {
            if (data.ok) {
                console.log(data);
                newfunk();
            }
          })
    })
    $('input[data-method_type="help"]').change(function(){
          console.log('[ AjaxUpdatePage ] Need_Help');
          if ($(this).prop('checked')) {var help = "1"} else { var help = '0'};
          var allInf = {
            modif_id : $('.js-item__material.item__material--active').data('modif_id'),
            material : $('.js-item__material.item__material--active').data('material'),
            group_id : $(this).data('group_id'),
            help : help,
            type : $(this).data('type'),
          }

        $.ajax({method: 'POST', url:'/constructor/Need_Help/', data:allInf, dataType:'json'}).then((data) => {
          if (data.ok) {
              console.log(data);
              newfunk();
          }
        })
      })
      $('.js-addfile').on('change',function(){
        var input = new FormData(document.getElementById('embroidery_form'));
        $.ajax({method: 'POST', url:'/constructor/Upload_File/', data:input, processData: false, contentType: false, dataType:'json'}).then((data) => {
          if($(this)[0].files[0].name.length > 30) {
            $('.js-embroidery__name').html($(this)[0].files[0].name.slice(0,30));
          } else {
            $('.js-embroidery__name').html($(this)[0].files[0].name);
          }
          $('.js-embroidery__name').attr('href', data.data.file_src)
          $(this).attr('data-file_id', data.data.file_id);
        })
        newfunk();
      })
      $('.js-delfile').on('click',function(){
        var file = {
         file_id : $('.js-addfile').data('file_id'),
       }
        $.ajax({method: 'POST', url:'/constructor/Clear_Fancy_file/', data:file, dataType:'json'}).then((data) => {
          if (data.ok) {
            console.log(data);
            newfunk();
          }
        })
      })
      $('.js-embroidery input[type="number"], .js-embroidery textarea').change(function(){
        var input = new FormData(document.getElementById('embroidery_form'));
        $.ajax({method: 'POST', url:'/constructor/Update_Fancywork/', data:input, processData: false, contentType: false, dataType:'json'}).then((data) => {
          if (data.ok) {
              console.log(data);
              newfunk();
          }
        })
      })
      $('.js-look-material').click(function(){
        var allInf = {
          modif_id : $('.js-item__material.item__material--active').data('modif_id'),
          material : $('.js-item__material.item__material--active').data('material'),
        }
        $.ajax({method: 'POST', url:'/constructor/Get_Material_Form/', data:allInf, dataType:'json'}).then((data) => {
          if (data.ok) {
            $.fancybox.open($.extend(true, {}, {
                type: 'html',
                touch: false,
                content: data.content,
                afterShow: function() {}
            }));
            if ($(document).find('.js-material-slider').html()) {
              $('.js-material-slider').slick({
                slidesToShow:1,
                slidesToScroll:1,
                arrows:true,
                dots:true,
                prevArrow:'<div class="js-material-prev"><svg width="20" height="12" viewBox="0 0 20 12" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M2.45705 4.82996L1.59347 5.68522L2.80889 5.68522L19.5 5.68522L19.5 6.31478L2.80889 6.31478L1.59347 6.31478L2.45705 7.17004L6.28826 10.9643L6.6401 10.6091L6.28826 10.9643C6.412 11.0869 6.412 11.2836 6.28826 11.4061C6.16184 11.5313 5.95488 11.5313 5.82846 11.4061L0.592798 6.22088C0.469064 6.09833 0.469064 5.90167 0.5928 5.77913L5.82846 0.593906C5.95488 0.4687 6.16184 0.4687 6.28826 0.593906C6.412 0.71645 6.412 0.913111 6.28826 1.03566L2.45705 4.82996Z" stroke="#FFF"/></svg></div>',
                nextArrow:'<div class="js-material-next"><svg width="20" height="12" viewBox="0 0 20 12" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M17.5429 7.17004L18.4065 6.31478H17.1911H0.5V5.68522H17.1911H18.4065L17.5429 4.82996L13.7117 1.03565L13.3599 1.39091L13.7117 1.03565C13.588 0.913109 13.588 0.716449 13.7117 0.593904C13.8382 0.468699 14.0451 0.468699 14.1715 0.593904L19.4072 5.77912C19.5309 5.90167 19.5309 6.09833 19.4072 6.22088L14.1715 11.4061C14.0451 11.5313 13.8382 11.5313 13.7117 11.4061C13.588 11.2836 13.588 11.0869 13.7117 10.9643L17.5429 7.17004Z" stroke="#FFF"/></svg></div>'
              });
            }
          } else {
              console.error('Can\'t get form');
          }
        })
      })
    $('.js-material-check').click(function(){
      console.log('[ AjaxUpdatePage ] Select_Color');
        var allInf = {
          modif_id : $('.js-item__material.item__material--active').data('modif_id'),
          material : $('.js-item__material.item__material--active').data('material'),
          type : $(this).data('type'),
          color_name : $(this).data('name'),
          color_id : $(this).data('object_id'),
          src : $(this).data('src'),
          material_type : $(this).data('material'),
        }

      $.ajax({method: 'POST', url:'/constructor/Select_Color/', data:allInf, dataType:'json'}).then((data) => {
        if (data.ok) {
            console.log(data);
            newfunk();
        }
      })
  });
  }
}

export {
  AjaxUpdate
}
